import styled from 'styled-components';
import { Button, Link, PrimaryButton } from '../../widgets/buttons';

export const ServiceCreditsContainer = styled.div`
    background-color: #ffffff;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const ServiceCreditsSectionTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 5px 0;
    strong {
        font-size: 14px;
        margin-bottom: 2px;
    }
    p {
        margin: 2px 0;
        padding: 0;
        font-size: 13px;
        line-height: 1.3;
    }
`;

export const ServiceCreditsTitleRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const TrialBadgeWrapper = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
`;

export const ServiceCreditsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
`;

export const CreditsInfoSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin: 2px 0 5px;
    gap: 3px;
`;

export const CreditsLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 5px;

    strong {
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
    }

    label {
        font-size: 14px;
        margin: 0;
        font-weight: 400;
    }
`;

export const CreditsWarning = styled.div<{ $hidden?: boolean }>`
    color: #dc3545;
    font-size: 13px;
    visibility: ${(props) => (props.$hidden ? 'hidden' : 'visible')};
`;

export const SelectorsRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;

    > div {
        flex: 1;
    }
`;

export const TierSelectionSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
        font-size: 11px;
        font-weight: 400;
        color: #000000;
        margin: 0;
    }
`;

export const ActionsSection = styled.div`
    margin-top: auto;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    border-top: 1px solid #dbe2e6;
    padding-top: 10px;
`;

export const PurchaseCreditsButton = styled(PrimaryButton)``;
export const ActivateTrialButton = styled(Button)``;

export const NoServiceMessage = styled.div`
    padding: 20px;
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 6px;
    text-align: center;

    p {
        margin: 0;
        color: #856404;
        font-size: 14px;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
`;

export const ErrorMessage = styled.div`
    padding: 16px;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    color: #721c24;
    font-size: 14px;
    margin-bottom: 16px;
`;

export const SuccessMessage = styled.div`
    padding: 16px;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 6px;
    color: #155724;
    font-size: 14px;
    margin-bottom: 16px;
`;

export const AutoRefillSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 11px;
    margin-top: auto;

    label {
        font-size: 11px;
    }

    p {
        font-size: 10px;
        color: #666666;
        margin: 0;
        padding-left: 0;
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: -70px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;

export const LinkSuccessPurchasingCreditsMessage = styled(Link)`
    color: #fff;
    font-weight: 700;
`;

export const PackageOptionLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
`;

export const PackageOptionPrice = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const PackageOriginalPrice = styled.span`
    color: #9ca3af;
    text-decoration: line-through;
`;

export const PackageDiscountBadge = styled.span`
    color: #16a34a;
    font-weight: 700;
    font-size: 12px;
`;
